import * as React from 'react';

import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useMessage } from '../context/MessageProvider';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2


import {FormProvider} from '../components/form/FormProvider';
import Form from '../components/form/Form';
import FormDropDownAndUsed from '../components/form/FormDropDownAndUsed';
import FormButton from '../components/form/FormButton';

import Header from "../components/Header";
import Subtitle from "../components/Subtitle";
import GoBack from "../components/GoBack";
import Spinner from "../components/Spinner";

import { newSectionA, saveSectionA, listSectionAsByAssessment } from '../models/sectiona';
import { listElephants } from '../models/elephants';
import { getFacility } from '../models/facility';
import { getAssessment } from '../models/assessments';


import {today, workdayTimeRanges} from "../utils/datetime";
import { findModel } from '../utils/model';

import { useQuery } from '@tanstack/react-query'

import { useConnectivity } from '../context/ConnectivityProvider';


export default function AssessmentSectionASelectPage({title = "EWP",...props}) {

    const {setSuccess, setError} = useMessage();
    //const {facility, elephants, assessment, sectionBs, newSectionB} = useLoaderData(); 
    const navigate = useNavigate();
    const params = useParams();
    const {isOnline} = useConnectivity();

    const {isLoading, data} = useQuery({
        queryKey: ['sectiona',params.assessmentId],
        queryFn: async() => {

            const elephants = await listElephants();
            const assessment = await getAssessment(params.assessmentId);
            return {
                facility: await getFacility(), 
                elephants,
                assessment,
                sectionAs: await listSectionAsByAssessment(params.assessmentId),
                newSectionA: newSectionA(),
                elephant: findModel(elephants,assessment.elephant_id),
            };
        },
        networkMode: "offlineFirst",
    });


    let observationWindows = [];
    let sectionList = [];
    let usedList = [];
    if (data) {

        const {facility, elephants, sectionAs, newSectionA} = data;

        console.log("section a assessment id: ", params.assessmentId);
        console.log("facility: ", facility, "elephants:", elephants);
        console.log("sectionAs: ", sectionAs);
        console.log("newSectionA", newSectionA);

        observationWindows = workdayTimeRanges(facility.start_of_day, facility.end_of_day);
        console.log(observationWindows);

        sectionList = sectionAs.map((cur)=>{
            return {
                value: cur.id,
                label: cur.observation_range,
            };
        });

        usedList = (sectionAs || []).filter((cur)=>{
            return cur.submitted_on
        }).map((cur)=>cur.id);
    }

    const onSubmit = async (inputData) => {
        try {
            console.log("onSubmit", inputData);

            const record = (data?.sectionAs || []).find((cur)=>cur.id === inputData.id);
            if (record === null) {
                throw new Error("Could not locate a section record with id: " + inputData.id);
            }

            console.log('matched record', record);


            const payload = {...record,observed_on: today()};
            console.log("payload: ", payload);
            const saveResult = await saveSectionA(payload,isOnline);
            console.log("sectiona save: ", saveResult);

            setSuccess("Started Section A");
            navigate("/assessments/" + data.assessment.id + "/sectiona/" + record.id);

        } catch(error) {
            console.error(error);
            setError(error.message);
        }

    }


    console.log("usedList:", usedList);

    // note you can play with the container maxwidth to spread out the window content appears in
    return (
        <Container component="main" maxWidth="sm">
            {isLoading && <Spinner />}
            {!isLoading && <>
                <GoBack onClick={()=>navigate(`/assessments/${data.assessment.id}`)} />
                <Header label={title} />
                <Subtitle>{data?.elephant?.name}</Subtitle>

                <FormProvider onSubmit={onSubmit} defaultValues={{id: ''}} >
                    <Form>
                        <Grid container spacing={2}>
                            <Grid xs={12} sm={12} sx={{justifyContent: "center", alignItems: "center"}}> 
                                <FormDropDownAndUsed name="id" label="Observation Timeframe" list={sectionList} required usedList={usedList} />
                            </Grid>

                            <Grid xs={12} sm={12}> 
                                <FormButton>Start</FormButton>
                            </Grid>
                        </Grid>

                    </Form>
                </FormProvider>

            </>}
        </Container>
    );
}

/*
                */